import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/visitors/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'

const defaultCardState = {
  visitors: [],
  visitorsById: {}
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultCardState,
        }
      }
    case ADD:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          visitors: addUniqueValueToArray({
            array: state[action.payload.cardId].visitors,
            value: action.payload.visitor.id
          }),
          visitorsById: {
            ...state[action.payload.cardId].visitorsById,
            [action.payload.visitor.id]: {
              ...state[action.payload.cardId].visitorsById[action.payload.visitor.id],
              ...action.payload.visitor
            }
          }
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.cardId]) return state

      const newState = {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          visitors: [ ...state[action.payload.cardId].visitors ],
          visitorsById: { ...state[action.payload.cardId].visitorsById },
        }
      }

      action.payload.array.forEach(visitor => {
        newState[action.payload.cardId].visitors = addUniqueValueToArray({
          array: newState[action.payload.cardId].visitors,
          value: visitor.id
        })
        newState[action.payload.cardId].visitorsById[visitor.id] = {
          ...newState[action.payload.cardId].visitorsById[visitor.id],
          ...visitor
        }
      })

      return newState
    }
    default: return state
  }
}

export function add ({ cardId, visitor }) {
  return {
    type: ADD,
    payload: {
      cardId,
      visitor
    }
  }
}

export function addArray ({ cardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      cardId,
      array
    }
  }
}
